import { fromJS } from 'immutable'

export const admissionState = fromJS({
  last_name: '',
  first_name: '',
  middle_name: '',
  suffix_name: '',
  dob: '',
  sex: '',
  civil_status: '',
  address: '',
  zip: '',
  citizenship: '',
  religion: '',
  meta: {
    contact1: '',
    intermediate_name: '',
    intermediate_address: '',
    intermediate_sy: '',
    secondary_name: '',
    secondary_address: '',
    secondary_sy: '',
  },
  // ---- advising
  is_open: false,
  level: '',
  full_name1: '',
  course_id: 0,
  course_code: '',
  course_name: '',
  curriculum_id: 0,
  curriculum_code: '',
  curriculum_name: '',
  paymentscheme_id: 0,
  paymentscheme_code: '',
  paymentscheme_name: '',
  scholarship_id: 0,
  scholarship_code: '',
  scholarship_name: '',
  // ---- account
  username: '',
  email: '',
  photo: '',
})

const initialState = fromJS({
  pending: false,
})

export default function admission(state = initialState, action) {
  switch (action.type) {
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/containers/Admission/reducer.js